
import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../system/mixins";
import { EntityFilterParameter } from "../../../system/filters";
import { DomainRegistry } from "../../../../domain";
import { UserFilterParameter } from "..";
import { User } from "../../../../domain/user";

@Component({
})
export default class BelongedAllDepartmentsUserFilterableMixin extends Mixins(ModelEditableMixin) {
  editingSource: UserFilterParameter;

  data(): any {
    return {
      users: null as User[],
    };
  }
  users: User[];

  created(): void {
    this.getBelongedAllDepartmentsUsers()
    .then(r => {
      this.users = r;
    });
  }

  get belongedAllDepartmentsUsers(): EntityFilterParameter {
    return this.editingSource.belongedAllDepartmentsUsers;
  }

  set belongedAllDepartmentsUsers(source: EntityFilterParameter) {
    this.writeProperty(s => s.belongedAllDepartmentsUsers = source);
  }

  updateBelongedAllDepartmentsUsers(shouldFilter: boolean): void {
    if (shouldFilter && !this.users) {
      // 全科所属職員情報を取得完了後に反映しなおすようにしている
      this.$logger.debug("全科所属職員情報を取得中です。");
      return;
    }
    this.belongedAllDepartmentsUsers = new EntityFilterParameter(shouldFilter ? this.users : null);
  }

  private async getBelongedAllDepartmentsUsers(): Promise<User[]> {
    try {
      const repository = DomainRegistry.user.getUserRepository();
      return await repository.getBelongedAllDepartmentsUsers();
    } catch (e) {
      this.$error(
        "全科所属職員情報取得失敗",
        "全科所属している職員情報を取得できませんでした。",
        e,
      );
      return null;
    }
  }
}
